"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));
var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));
var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));
var _react = _interopRequireWildcard(require("react"));
var _lodash = _interopRequireDefault(require("lodash"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _reactBootstrap = require("react-bootstrap");
var _styles = _interopRequireDefault(require("./styles.scss"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
var CLASS_NAME = _styles.default['base-modal'];
var BaseModal = /*#__PURE__*/function (_PureComponent) {
  (0, _inherits2.default)(BaseModal, _PureComponent);
  var _super = _createSuper(BaseModal);
  function BaseModal() {
    (0, _classCallCheck2.default)(this, BaseModal);
    return _super.apply(this, arguments);
  }
  (0, _createClass2.default)(BaseModal, [{
    key: "renderHeader",
    value: function renderHeader() {
      if (_lodash.default.isNil(this.props.title)) {
        return null;
      }
      var title = /*#__PURE__*/_react.default.createElement("p", {
        className: this.props.icon ? 'title' : 'title no-icon'
      }, this.props.title);
      if (this.props.type === 'dialog' && this.props.onHide) {
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, null, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Title, null, /*#__PURE__*/_react.default.createElement("button", {
          type: "button",
          className: "close",
          onClick: this.props.onHide
        }, /*#__PURE__*/_react.default.createElement("span", {
          "aria-hidden": "true"
        }, "\xD7"), /*#__PURE__*/_react.default.createElement("span", {
          className: "sr-only"
        }, "Close")), this.props.icon, title));
      }
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Header, {
        closeButton: !this.props.icon
      }, /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Title, null, this.props.icon, title));
    }
  }, {
    key: "renderBody",
    value: function renderBody() {
      if (!this.props.body) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Body, null, this.props.body);
    }
  }, {
    key: "renderFooter",
    value: function renderFooter() {
      if (!this.props.footer) {
        return null;
      }
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Footer, null, this.props.footer);
    }
  }, {
    key: "render",
    value: function render() {
      var content = /*#__PURE__*/_react.default.createElement(_react.Fragment, null, this.renderHeader(), this.renderBody(), this.renderFooter());
      var modalProps = _objectSpread(_objectSpread({}, this.props), {}, {
        className: "".concat(this.props.className, " ").concat(CLASS_NAME),
        id: this.props.id,
        icon: undefined,
        body: undefined,
        footer: undefined,
        title: undefined,
        children: content
      });
      if (this.props.type === 'dialog') {
        // ModalDialog does not have onHide handler
        modalProps = _lodash.default.omit(modalProps, 'onHide');
        return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal.Dialog, modalProps);
      }
      return /*#__PURE__*/_react.default.createElement(_reactBootstrap.Modal, modalProps);
    }
  }]);
  return BaseModal;
}(_react.PureComponent);
BaseModal.propTypes = {
  body: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element, _propTypes.default.string]),
  className: _propTypes.default.string,
  footer: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.element), _propTypes.default.element, _propTypes.default.string]),
  icon: _propTypes.default.oneOfType([_propTypes.default.element, _propTypes.default.string]),
  id: _propTypes.default.string,
  onHide: _propTypes.default.func,
  show: _propTypes.default.bool,
  title: _propTypes.default.string,
  type: _propTypes.default.string
};
BaseModal.defaultProps = {
  body: function body() {
    return /*#__PURE__*/_react.default.createElement("div", null);
  },
  className: '',
  footer: function footer() {
    return /*#__PURE__*/_react.default.createElement("div", null);
  },
  icon: null,
  id: '',
  show: false,
  onHide: function onHide() {
    return null;
  },
  title: 'Modal',
  type: null
};
var _default = BaseModal;
exports.default = _default;